import type { Middleware } from 'redux';

export const middleware: Middleware =
    ({ dispatch, getState }) =>
    next =>
    action => {
        if (typeof action === 'function') {
            action(dispatch, getState);
        }

        return next(action);
    };
